import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

var marked = require('marked');
marked.setOptions({
  gfm: true,
  tables: true,
  breaks: true,
  sanitize: true
});

import Teaching_Item from '../components/Teaching_Item';
import Container from '../components/Shared/Container';
import InnerContainer from '../components/Shared/InnerContainer';
import SectionHeader from '../components/Shared/SectionHeader';
import SectionText from '../components/Shared/SectionText';

const TeachingPage = ({data}) => (
  <div style={{ minHeight: '100vh'}}>
    <Container teaching>
      <InnerContainer light>
        <SectionHeader light>Teaching</SectionHeader>
          <SectionText dangerouslySetInnerHTML={ {__html:
              marked(data.allContentfulPage.edges[0].node.mainText.body.body,
              {sanitize: true})}}
          />
      </InnerContainer>
    </Container>
    <Container small grey>
      <InnerContainer>
        <SectionHeader>Previous Courses</SectionHeader>
        <FlexContainer>
          {data.allContentfulPage.edges[0].node.additionalItems &&
            data.allContentfulPage.edges[0].node.additionalItems.map((item, i) => (
            <Teaching_Item key={i} class={item} />
          ))}
        </FlexContainer>
    </InnerContainer>
  </Container>
  </div>
)

export default TeachingPage;

export const query = graphql`
  query TeachingQuery {
    allContentfulPage (
    filter: {
      title: {
      eq: "Teaching"
    	}
    }
    ) {
    edges {
      node {
        title
        mainText {
          title
          body {
            body
          }
        }
        additionalItems {
          ... on ContentfulPublication {
            title
            authors
            year
            journal
            doiNumber
            abstractUrl
          }
          ... on ContentfulCourse {
            title
            institution
            semester
            courseType
            current
          }
          ... on ContentfulResearch {
            title
            institution
            description {
              id
            }
            order
            relavantPapers {
              title
              doiNumber
            }
          }
        }
      }
    }
  }
}
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/pages/teaching.js